import type { CrosshairSyncGroup, CrosshairSyncData } from '../types/chart'

/**
 * Creates a sync group for broadcasting crosshair position across multiple charts.
 * Pass the same group instance to each EdgeChart's `crosshairSync` prop.
 *
 * `publish(sourceId, null)` is a clear signal: peer subscribers should remove
 * any crosshair line drawn from this group. Used when a chart leaves the
 * group so peers don't keep painting the stale position.
 */
export function createCrosshairSyncGroup(): CrosshairSyncGroup {
  const handlers = new Map<string, (data: CrosshairSyncData | null) => void>()
  let publishing = false

  return {
    subscribe(id, handler) {
      handlers.set(id, handler)
    },
    unsubscribe(id) {
      handlers.delete(id)
    },
    publish(sourceId, data) {
      if (publishing) return
      publishing = true
      handlers.forEach((handler, id) => {
        if (id !== sourceId) handler(data)
      })
      publishing = false
    },
  }
}
